define('constants/signupNumberIntentConstants',[], function() {
    return {
        'forward': 1,
        'new': 2
    };
});
